var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    attrs: {
      id: "productDetail"
    }
  }, [_c("a-tabs", {
    attrs: {
      animated: false,
      activeKey: _vm.tabKey
    },
    on: {
      change: _vm.tabChange
    }
  }, [_c("a-tab-pane", {
    key: "1",
    attrs: {
      tab: _vm.$t("productDetail.basicParameter")
    }
  }, [_vm.tabKey == 1 ? _c("basicParameter", {
    ref: "basicParameter",
    attrs: {
      "product-id": _vm.productId
    },
    on: {
      getId: _vm.getId
    }
  }) : _vm._e()], 1), _vm.productId > 0 ? _c("a-tab-pane", {
    key: "2",
    attrs: {
      tab: _vm.$t("productDetail.priceStock")
    }
  }, [_vm.tabKey == 2 ? _c("priceStock", {
    ref: "priceStock",
    attrs: {
      "product-id": _vm.productId,
      "spec-flag": _vm.specFlag
    }
  }) : _vm._e()], 1) : _vm._e(), _vm.productId > 0 ? _c("a-tab-pane", {
    key: "3",
    attrs: {
      tab: _vm.$t("productDetail.pictureDescription")
    }
  }, [_vm.tabKey == 3 ? _c("pictureDescription", {
    ref: "pictureDescription",
    attrs: {
      "product-id": _vm.productId
    }
  }) : _vm._e()], 1) : _vm._e(), _vm.productId > 0 ? _c("a-tab-pane", {
    key: "5",
    attrs: {
      tab: _vm.$t("productDetail.Description")
    }
  }, [_vm.tabKey == 5 ? _c("descriptionVue", {
    ref: "dsc",
    attrs: {
      "product-id": _vm.productId
    }
  }) : _vm._e()], 1) : _vm._e(), _vm.productId > 0 ? _c("a-tab-pane", {
    key: "6",
    attrs: {
      tab: "SEO"
    }
  }, [_vm.tabKey == 6 ? _c("SEO", {
    ref: "SEO",
    attrs: {
      "product-id": _vm.productId
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };